import React, { useState } from "react";
import { Modal, Spinner } from "@shopify/polaris";
const LoadingScreen = () => {
  const [popupActive, setPopupActive] = useState(true);
  return (
    <div className="loadingScreen">
      <div className="loadingSpinner">
        <Spinner />
      </div>
    </div>
  );
};

export default LoadingScreen;
